module.exports = __webpack_public_path__ + "static/media/c2.713860d4.jpg";